export class ProductType {
    public static readonly ACCESSORY = 'accessory';
    public static readonly MAIN = 'main';
}